const faqs = [
    {
        id: 1,
        heading: 'What are the different types of coffee drinks?',
        content: 'Learn about the different coffee drinks we offer, including espresso, cappuccino, latte, americano, and cold brew, each with its unique flavor profile and preparation method.',
    },
    {
        id: 2,
        heading: 'Where do you source your coffee beans from?',
        content: 'We source our premium coffee beans from sustainable farms in regions like Ethiopia, Colombia, and Brazil, ensuring freshness and supporting fair-trade practices.',
    },
    {
        id: 3,
        heading: 'What brewing methods do you use?',
        content: 'We use a variety of brewing methods, including espresso machines, pour-over, French press, and cold brew, to bring out the unique flavors and aromas of our coffee beans.',
    },
    {
        id: 4,
        heading: 'Do you offer vegan or dairy-free options?',
        content: 'Yes, we offer a variety of dairy-free milk options, such as almond milk, oat milk, and soy milk, to suit vegan and lactose-intolerant customers.',
    },
    {
        id: 5,
        heading: 'Do you have a loyalty program?',
        content: 'Yes, we offer a loyalty program where you can earn points with every purchase and redeem them for free drinks, discounts, and exclusive offers.',
    },
];

export default faqs;